import { Component } from '@angular/core';

@Component({
  selector: 'app-message-three',
  templateUrl: './message-three.component.html',
  styleUrls: ['./message-three.component.scss']
})
export class MessageThreeComponent {

}
